import { Typography, Flex } from "antd";
import { colors } from "@libertify/ui/theme-v2";
import { useTranslate } from "#src/hooks";
import type { InsightComment as InsightCommentType } from "../../types";
import { formatCommentTimestamp } from "./utils";
import { radius } from "@libertify/ui";

export type InsightCommentProps = {
  comment: InsightCommentType;
  isEditing?: boolean;
  onSaveEdit?: (body: string) => void;
  onCancelEdit?: () => void;
};

export const InsightComment = ({
  comment,
  isEditing,
  onSaveEdit,
  onCancelEdit,
}: InsightCommentProps) => {
  const t = useTranslate();
  return (
    <Flex
      vertical
      gap={4}
      style={{
        flex: 1,
        backgroundColor: isEditing ? undefined : colors.surface.muted,
        borderRadius: radius.box,
        padding: "8px 12px",
      }}
    >
      <Typography.Paragraph
        style={{ marginBottom: 0 }}
        editable={{
          editing: isEditing,
          autoSize: { minRows: 2, maxRows: 4 },
          icon: <></>,
          onChange: (value) => {
            const trimmed = value.trim();
            if (trimmed && trimmed !== comment.body) {
              onSaveEdit?.(trimmed);
            } else {
              onCancelEdit?.();
            }
          },
          onCancel: () => onCancelEdit?.(),
        }}
      >
        {comment.body}
      </Typography.Paragraph>

      {!isEditing && (
        <Flex gap={6} style={{ marginTop: 4 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            {formatCommentTimestamp(comment.created_at, t)}
          </Typography.Text>
          {comment.updated_at && (
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
              {t("media.analytics.insights.commentEdited")}
            </Typography.Text>
          )}
        </Flex>
      )}
    </Flex>
  );
};
